import { logger } from '@/logger/createLogger'
import { useUserStore, useUserStoreActions } from '@/stores/user'
import { useEffect, useState } from 'react'

type Status = 'error' | 'idle' | 'loading' | 'success'

export const UserProfile = () => {
  const displayName = useUserStore(state => state.displayName)
  const { refreshSubscriberState } = useUserStoreActions()
  const [status, setStatus] = useState<Status>(displayName ? 'success' : 'idle')

  useEffect(() => {
    // fetch if displayName is not set
    if (displayName) {
      setStatus('success')
      return
    }

    setStatus('loading')
    refreshSubscriberState()
      .then(() => {
        setStatus('success')
      })
      .catch(error => {
        // TODO: add mechanism to retry refreshing subscriber state?
        setStatus('error')
        logger.error('Failed to refresh subscriber state', error)
        throw error
      })
  }, [displayName, refreshSubscriberState])

  return (
    <div>
      {status === 'loading' && (
        <div className="animate-pulse">
          <p className="text-sm text-skeleton">Loading subscriber</p>
        </div>
      )}
      {/* TODO: remove or move error handling */}
      {status === 'error' && (
        <p className="text-sm text-negative-light">Error fetching subscriber</p>
      )}
      {status === 'success' && (
        <p className="line-clamp-2 text-sm">{displayName}</p>
      )}
    </div>
  )
}
